<template>
<div>
  <a v-show="false"
     ref="download"
     :href="link.href"
     :download="link.download">
  </a>
</div>
</template>

<script>
export default {
  name: 'save-blob',

  props: {
    target: Object

  },

  data () {
    return {
      link: {
        href: '',
        download: ''
      }
    }
  },

  watch: {
    target: function (value) {
      if (value != null) {
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(value.blob, value.filename)
        } else {
          if (this.link.href !== '') {
            window.URL.revokeObjectURL(this.link.href)
          }
          this.link.href = window.URL.createObjectURL(value.blob)
          this.link.download = value.filename
          const vm = this
          setTimeout(function () {
            vm.$refs.download.click()
          }, 100)
        }
      }
    }
  }
}
</script>

<style lang="less">
</style>
